import { Controller } from '@eigtech/ui-shared-forms/shadcn'
import { Checkbox } from '@eigtech/ui/components/checkbox'
import { Label } from '@eigtech/ui/components/label'
import { Stack } from '@eigtech/ui/components/stack'
import {
  ContactForm,
  ContactFormArrayField,
  ContactFormInputField,
  ContactFormMaskedInputField,
  useContactFormArrayFieldRowContext,
  useContactFormContext,
} from './ContactFormSchema/ContactFormSchema'
import { ContactInfoRowContainer } from './ContactInfoRowContainer'

export function PhoneFieldArray() {
  return (
    <ContactFormArrayField
      RowContainer={RowContainer}
      defaultValue={{ extensionPrefix: 'x' } as ContactForm['phones'][number]}
      name="phones"
      renderRow={PhoneField}
    />
  )
}

function RowContainer(props: { children: React.ReactNode; index: number }) {
  return <ContactInfoRowContainer {...props} indexKey="primaryPhoneIndex" />
}

export function PhoneField() {
  const { control } = useContactFormContext()
  const { index, name } = useContactFormArrayFieldRowContext<'phones'>()

  return (
    <Stack className="w-full gap-3">
      <div className="grid grid-cols-6 gap-2">
        <div className="col-span-4">
          <ContactFormMaskedInputField
            label="Phone"
            mask="000-000-0000"
            name={`phones.${index}.phone`}
          />
        </div>
        <div className="col-span-2">
          <ContactFormInputField
            inputProps={{ maxLength: 10 }}
            label="Extension"
            name={`${name}.extension`}
          />
        </div>
      </div>

      <Controller
        control={control}
        name="primaryPhoneIndex"
        render={({ field: { onChange: setPrimaryIndex, value: primaryIndex, ...props } }) => (
          <Label className="flex flex-row items-center gap-2">
            <Checkbox
              checked={primaryIndex === index}
              className="mt-0"
              onCheckedChange={(checked) =>
                checked ? setPrimaryIndex(index) : setPrimaryIndex(null)
              }
              {...props}
            />
            Is Primary
          </Label>
        )}
      />
    </Stack>
  )
}
